import React, { useEffect, useState } from 'react'
import useStyles from "../MasterData.css";
import translation from "../../../i18n/i18.json";
import {
    Button,
    Checkbox,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    FormLabel,
    Grid,
    MenuItem,
    Select,
    Switch,
    TextField,
  } from "@material-ui/core";
import { AccSubCat } from '../../../models/Master/AccSubCat';
import { FormError } from "../../../models/FormValidation/FormError";
import { FormFieldMeta } from '../../../models/FormValidation/FormFieldMeta';
import { FormUtil } from '../../../utils/FormUtil';
import { Company } from '../../../models/Company';
import { ReconAC } from '../../../models/ReconAC';
import { MasterDataUtil } from '../../../utils/masterData/MasterDataUtil';
import { MasterDataService } from '../../../services/MasterDataService';
import AllActions from '../../../actions';
import { useDispatch } from 'react-redux';
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import { InforDisplyaDuration } from '../../../constants/AppConstants';
import { VendorDetailService } from '../../../services/VendorDetailService';

  interface AccSubCategoryAddDialogProps {
    open: boolean;
    //message: string;
    //onSuccessUpdate: any;
    handleClose:any;
    //dataToUpdate: AccSubCat;
    dataObj:AccSubCat;
    setDataObj:any;
  }
export default function AccSubCategoryAddDialog(props:AccSubCategoryAddDialogProps) {
    const classes = useStyles();
    const dispatch = useDispatch();
    const { open, handleClose, dataObj, setDataObj} = props;
    const initialState:AccSubCat = {
      id: 0,
      subCategoryCode: "",
      subcategoryName: "",
      companyCode: "",
      accountGroupCode: "",
      isActive:true
  }
    //const [dataObj, setDataObj] = useState<AccSubCat>(dataToUpdate);
    // const [open, setOpen] = useState(isOpen);
    // useEffect(() => { setOpen(isOpen)}, [isOpen] );
    const [formErrors, setFormErrors] = useState<FormError[]>([]);
    const [companyCodeList, setCompanyCodeList] = useState(Array<Company>());
    const [reconAcList, setReconAcList] = useState(Array<ReconAC>());
    const [fistSubmitDone, setFistSubmitDone] = useState(false);
    const validateFieldsData:Array<FormFieldMeta> = [
      { fieldName: "subCategoryCode", isRequired: true, reuiredMsg: "subCategoryCode" },
      { fieldName: "subcategoryName", isRequired: true, reuiredMsg: "subcategoryName" },
      { fieldName: "companyCode", isRequired: true, reuiredMsg: "companyCode" },
      { fieldName: "accountGroupCode", isRequired: true, reuiredMsg: "accountGroupCode" },
  ];
  // useEffect(() => { 
  //   setDataObj(dataToUpdate);
  // }, [dataToUpdate] );

    const prepareForRequest = () => {
      dispatch(AllActions.backDropActions.openBackDrop());
    };
  
    const compeleteRequest = (success: boolean, message?: string) => {
      dispatch(AllActions.backDropActions.closeBackDrop());
      if (message) {
        if (success) {
          dispatch(AllActions.infoActions.openInforSuccess(message, InforDisplyaDuration.common));
        } else {
          dispatch(AllActions.infoActions.openInforError(message, InforDisplyaDuration.common));
        }
      }
    };

    useEffect(() => {
      if(open){
        prepareForRequest();
        VendorDetailService.getCompany(
            function(companyData: Array<Company>){
              setCompanyCodeList(companyData);
              compeleteRequest(true);
            },
            function(error: Error){
              setCompanyCodeList([]);
              compeleteRequest(false);
            }
          );
      }
    }, [open])
  
    useEffect(() => {
      if(dataObj.companyCode && dataObj.companyCode !== ""){
        prepareForRequest();
        VendorDetailService.getReconAC(
          dataObj.companyCode,
          "",
          function(reconACData: Array<ReconAC>){
            setReconAcList(reconACData);
            compeleteRequest(true);
          },
          function(error: Error){
            setCompanyCodeList([]);
            compeleteRequest(false);
          }
        );
      }
    }, [dataObj.companyCode])

    const saveObject = (onSaveCallback:(status:boolean) => void) => {
      prepareForRequest();
        MasterDataService.saveAccSubCategory(
          dataObj,
          function(accSubCategory: AccSubCat){
            if(dataObj.id === 0){
              compeleteRequest(true, translation.master_subcat_dialog_save_suc);
            }
            else {
              compeleteRequest(true, translation.master_subcat_dialog_update_suc);
            }
            onSaveCallback(true);
          },
          function(error: Error){
            compeleteRequest(false, translation.master_add_dialog_save_error);
            onSaveCallback(false);
          }       
        );
    };

    useEffect(() => {
      if (fistSubmitDone) {
        validateData();
      }
    }, [dataObj]);
    
    const handleExit = (e: any) => {
      setDataObj(initialState);
      setFormErrors([]);
      setFistSubmitDone(false);
    };

    // const handleClose = (e: any) => {
    //   setOpen(false);
    // };

    const validateData = () => {
      let vailidity = MasterDataUtil.validateData(validateFieldsData, dataObj);
      if(vailidity.isValid){
        setFormErrors([]);
      }
      else{
        setFormErrors(vailidity.errorsList);
      }
      return vailidity.isValid;
    };

    const handleSaveAddNew = (e: any) => {
      setFistSubmitDone(true);
      if(validateData()){
        saveObject(function(status:boolean){
          setDataObj(initialState);
        });
      }
    };

    const handleSaveExit = (e: any) => {
      setFistSubmitDone(true);
      if(validateData()){
        saveObject(function(status:boolean){
          //setOpen(false);
          handleClose();
        });
      }
    };
    

    const handleChange = (input: string) => (e: any) => {
      if(e.target.type === "checkbox"){
        setDataObj({
          ...dataObj,
          [input]:e.target.checked
        });
      }
      else if(input === "companyCode"){
        setDataObj({
          ...dataObj,
          "companyCode":e.target.value,
          "accountGroupCode":""
        });
      }
      else {
        setDataObj({
          ...dataObj,
          [input]:e.target.value
        });
      }
      
    };

    const getErrorState = (input: string) => {
      return MasterDataUtil.getErrorState(input, formErrors);
    };

    return (
        <div  className={classes.popUpOuter}>
      <Dialog
         open={open}
        onClose={handleClose}
        onExit={handleExit}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle  className={classes.popUpHeader} id="alert-dialog-title">{translation.master_subcat_dialog_title}</DialogTitle>
        <DialogContent className={classes.NoPopWrapper} >
          <div>
          <Grid container spacing={2} item xs={12} sm={12} md={12} lg={12}>
          <Grid item xs={12} sm={12} md={6} lg={4}>
            <Grid item xs={12} sm={12} md={12} lg={12}>
              <span className={classes.createLbl}>
                {translation.master_subcat_dialog_code}
              </span>
            </Grid>
            <Grid className={classes.inputWrapper_Req}>
              <TextField
                variant="outlined"
                value={dataObj.subCategoryCode || ""}
                onChange={handleChange("subCategoryCode")}
                error={getErrorState("subCategoryCode")}
              />
            </Grid>
          </Grid>
          <Grid item xs={12} sm={12} md={6} lg={4}>
            <Grid item xs={12} sm={12} md={12} lg={12}>
              <span className={classes.createLbl}>
                {translation.master_subcat_dialog_name}
              </span>
            </Grid>
            <Grid className={classes.inputWrapper_Req}>
              <TextField
                variant="outlined"
                value={dataObj.subcategoryName || ""}
                onChange={handleChange("subcategoryName")}
                error={getErrorState("subcategoryName")}
              />
            </Grid>
          </Grid>
          </Grid>
          <Grid container spacing={2} item xs={12} sm={12} md={12} lg={12}>
          <Grid item xs={12} sm={12} md={6} lg={4}>
            <Grid item xs={12} sm={12} md={12} lg={12}>
              <span className={classes.createLbl}>
                {translation.master_subcat_dialog_companycode}
              </span>
            </Grid>
            <Grid className={classes.inputWrapper_Req}>
            <Select 
                variant="outlined"
                value={dataObj.companyCode || ""}
                onChange={handleChange("companyCode")}
                error={getErrorState("companyCode")}
              >
                {companyCodeList.map((obj, index) => (
                  <MenuItem key={obj.code} value={obj.code}>
                    {obj.name}
                  </MenuItem>
                ))}
              </Select>
            </Grid>
          </Grid>
          <Grid item xs={12} sm={12} md={6} lg={4}>
            <Grid item xs={12} sm={12} md={12} lg={12}>
              <span className={classes.createLbl}>
                {translation.master_subcat_dialog_accgropucode}
              </span>
            </Grid>
            <Grid className={classes.inputWrapper_Req}>
            <Select
                variant="outlined"
                value={dataObj.accountGroupCode || ""}
                onChange={handleChange("accountGroupCode")}
                error={getErrorState("accountGroupCode")}
              >
                {reconAcList.map((obj, index) => (
                  <MenuItem key={obj.code} value={obj.code}>
                    {obj.name}
                  </MenuItem>
                ))}
              </Select>
            </Grid>
          </Grid>
          </Grid>
          <Grid container spacing={2} item xs={12} sm={12} md={12} lg={12}>
          <Grid item xs={12} sm={12} md={6} lg={4}>
            <Grid item xs={12} sm={12} md={12} lg={12}>
              <span className={classes.createLbl}>
                {translation.master_subcat_dialog_isactive}
              </span>
            </Grid>
            <Grid className={classes.inputWrapper_Req}>
            <Switch
                checked={dataObj.isActive}
                onChange={handleChange("isActive")}
            ></Switch>
            </Grid>
          </Grid>
          </Grid>
          </div>
          {/* <Grid hidden={!isShowUrgent} className={classes.popdataRow}>
            <span className={classes.popUpLBL}>{translation.dashboard_approve_isuserurgent}</span>
            <Checkbox value={isUrgent}></Checkbox>
          </Grid> */}
        </DialogContent>
        <DialogActions>
        <div style={{ margin:"20px ​10px 15px 0"}}>
        <div className={classes.greenBtnWrapper}>
          <Button onClick={handleSaveAddNew} color="primary">
          <CheckCircleIcon></CheckCircleIcon>
          {translation.master_add_dialog_save_add_btntxt}
          </Button>
          </div>
          <div className={classes.greenBtnWrapper}>
          <Button onClick={handleSaveExit} color="primary">
            <CheckCircleIcon></CheckCircleIcon>
          {translation.master_add_dialog_save_exit_btntxt}
          </Button>
          </div>
          <div className={classes.grayBtnWrapper}>
          <Button onClick={handleClose} color="primary" autoFocus>
          {translation.master_add_dialog_cancelbtntxt}
          </Button>
          </div>
          </div>
        </DialogActions>
      </Dialog>
    </div>
    )
}
